import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_170: DocMigration = {
  maxSchemaVersion: "0.0.170",
  description: "Window refactor: replace and unify descriptor short name and window tag override with reported name",
  apply(json: any) {
    for (const settingId in json.settings) {
      const setting = json.settings[settingId];
      //catalog window updates
      if (setting.type === "WINDOW_CATALOG_SETTINGS") {
        for (const typeId in setting.windowTypes) {
          const windowDescriptor = setting.windowTypes[typeId];
          //set reportedName to former shortName
          if (windowDescriptor.shortName !== undefined) {
            const shortName = windowDescriptor.shortName;
            windowDescriptor["reportedName"] = shortName;
            delete windowDescriptor.shortName;
          }
        }
      }
    }
    //window updates
    for (const roomLayoutId in json.roomLayouts) {
      const roomLayout = json.roomLayouts[roomLayoutId];
      const openingPatterns = roomLayout.openingPatterns;
      for (const patternId in openingPatterns) {
        const openingPattern = openingPatterns[patternId];
        for (const openingId in openingPattern.openings) {
          const window = openingPattern.openings[openingId];
          if (window.type === "WINDOW") {
            //set reportedName to former tagOverride
            if (window.tagOverride !== undefined) {
              const tagOverride = window.tagOverride;
              window["reportedName"] = tagOverride;
              delete window.tagOverride;
            }
          }
        }
      }
    }

    return json;
  },
};

export default migration_0_0_170;
